/* This file is autogenerated, see readme.md for instructions */
import UnExposeSvgIcon from '@bloomreach/banana-theme/icons/un-expose.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UnExposeIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UnExposeSvgIcon />
    </Icon>
  );
});

UnExposeIcon.displayName = 'UnExposeIcon';

export default UnExposeIcon;
